export default __webpack_public_path__ + "static/media/ce.4c5be815.svg";